<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['values', 'barWidth'],
  watch: {
    values() {
      this.chartData.labels = this.values[0].labels,
      this.chartData.datasets = this.values
      this.$data._chart.update()
    }
  },
  data () {
    return {
      chartData: {
        labels: [],
        datasets: []
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                color: "#e2e2e2",
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [{
            stacked: true,
            gridLines: {
              color: "#e2e2e2",
              drawOnChartArea: true
            }
          }]
        }
      },
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
